import { actionTypes } from '../../../types';

// Action creator for Apple user login request
export const appleUserLogin = (payload) => ({
    type: actionTypes.APPLE_USER_LOGIN_REQUEST,
    payload,
});

// Action creator for successful Apple user login
export const appleUserLoginSuccess = (payload) => ({
    type: actionTypes.APPLE_USER_LOGIN_SUCCESS,
    payload,
});

// Action creator for failed Apple user login
export const appleUserLoginFailure = (payload) => ({
    type: actionTypes.APPLE_USER_LOGIN_FAILURE,
    payload,
});

// Action creator for resetting Apple user login state
export const appleUserLoginReset = () => ({
    type: actionTypes.APPLE_USER_LOGIN_RESET,
});

// Action creator for resetting all Apple user login reducer state
export const appleUserLoginResetAll = () => ({
    type: actionTypes.APPLE_USER_LOGIN_RESET_ALL,
});
